export default __webpack_public_path__ + "static/media/DietmarHeyde.73877fe2.mp4";